export const config = {
  "skinName":"Gangabet",
  "partner": 18,
  "countryFixed": "pe",
  "currency": [
    {
      "name":"PEN"
    },{
      "name":"CLP"
    },
    {
      "name":"BRL"
    },
    {
      "name":"MXN"
    },
    {
      "name": "VES"
    }
  ],
  "logo":"https://images.virtualsoft.tech/m/msjT1664299907.png",
  "favicon":"https://images.virtualsoft.tech/m/msjT1664386261.png",
  "isotipo":"https://images.virtualsoft.tech/m/msjT1664387526.png",
  "urlApi":{
    "isWsConnection":false,
    "url":"https://affiliatesapi.virtualsoft.tech",
    "ws":""
  },
  "langDefault":"es",

  "header":{
    "image":"/assets/images/Mockup_gangabet.png",
    "text":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad"
  },
  "homeAboutUs": {
        "cl": [
                {
                  "title":"Gangabet",
                  "icon":"fa fa-globe-americas",
                  "text":"Gangabet es una marca de Wymsistem Bv, compañía registrada en el gobierno de Curazao, con domicilio en Fransche Bloemweg 4 bajo el número de licencia de E-Gaming 8048 / JAZ. <br><br>Actualmente contamos con oficinas centrales en Europa y en América , localizadas en Lima, Ciudad de México, Maracay y Almería.",
                },
                {
                  "title":"Servicio",
                  "icon":"fas fa-headset",
                  "text":"Gangabet se esfuerza en ofrecer un servicio justo, personal transparente en el cual tratamos de mejorar el conocimiento que nuestros clientes tienen acerca del juego online.",
                },
                {
                  "title":"Juego responsable",
                  "icon":"fa fa-star",
                  "text":"En Gangabet, continuaremos esforzándonos, trabajando duro y enfocándonos en la innovación y desarrollo de nuevos productos, así como en continuar asentando los estándares para un uso responsable del juego.",
                },
                {
                  "title":"Nuestro nombre",
                  "icon":"fa fa-pen-nib",
                  "text":"Quizás te preguntaste de dónde proviene nuestro nombre Gangabet, este nombre se ha escogido por diversos motivos, el primero es que es corto, intuitivo y casi imposible de olvidar, el segundo es porque queremos que nuestros clientes sigan nuestro lema: <br>“No es una oferta, ni es un regalo, ¡Es Gangabet!”",
                }
        ],
        "mx": [
          {
            "title":"Gangabet",
            "icon":"fa fa-globe-americas",
            "text":"Gangabet es una marca de Wymsistem Bv, compañía registrada en el gobierno de Curazao, con domicilio en Fransche Bloemweg 4 bajo el número de licencia de E-Gaming 8048 / JAZ. <br><br>Actualmente contamos con oficinas centrales en Europa y en América , localizadas en Lima, Ciudad de México, Maracay y Almería.",
          },
          {
            "title":"Servicio",
            "icon":"fas fa-headset",
            "text":"Gangabet se esfuerza en ofrecer un servicio justo, personal transparente en el cual tratamos de mejorar el conocimiento que nuestros clientes tienen acerca del juego online.",
          },
          {
            "title":"Juego responsable",
            "icon":"fa fa-star",
            "text":"En Gangabet, continuaremos esforzándonos, trabajando duro y enfocándonos en la innovación y desarrollo de nuevos productos, así como en continuar asentando los estándares para un uso responsable del juego.",
          },
          {
            "title":"Nuestro nombre",
            "icon":"fa fa-pen-nib",
            "text":"Quizás te preguntaste de dónde proviene nuestro nombre Gangabet, este nombre se ha escogido por diversos motivos, el primero es que es corto, intuitivo y casi imposible de olvidar, el segundo es porque queremos que nuestros clientes sigan nuestro lema: <br>“No es una oferta, ni es un regalo, ¡Es Gangabet!”",
          }
        ],
        "pa": [
          {
            "title":"Gangabet",
            "icon":"fa fa-globe-americas",
            "text":"Gangabet es una marca de Wymsistem Bv, compañía registrada en el gobierno de Curazao, con domicilio en Fransche Bloemweg 4 bajo el número de licencia de E-Gaming 8048 / JAZ. <br><br>Actualmente contamos con oficinas centrales en Europa y en América , localizadas en Lima, Ciudad de México, Maracay y Almería.",
          },
          {
            "title":"Servicio",
            "icon":"fas fa-headset",
            "text":"Gangabet se esfuerza en ofrecer un servicio justo, personal transparente en el cual tratamos de mejorar el conocimiento que nuestros clientes tienen acerca del juego online.",
          },
          {
            "title":"Juego responsable",
            "icon":"fa fa-star",
            "text":"En Gangabet, continuaremos esforzándonos, trabajando duro y enfocándonos en la innovación y desarrollo de nuevos productos, así como en continuar asentando los estándares para un uso responsable del juego.",
          },
          {
            "title":"Nuestro nombre",
            "icon":"fa fa-pen-nib",
            "text":"Quizás te preguntaste de dónde proviene nuestro nombre Gangabet, este nombre se ha escogido por diversos motivos, el primero es que es corto, intuitivo y casi imposible de olvidar, el segundo es porque queremos que nuestros clientes sigan nuestro lema: <br>“No es una oferta, ni es un regalo, ¡Es Gangabet!”",
          }
        ],
        "pe": [
          {
            "title":"Gangabet",
            "icon":"fa fa-globe-americas",
            "text":"Gangabet es una marca de Wymsistem Bv, compañía registrada en el gobierno de Curazao, con domicilio en Fransche Bloemweg 4 bajo el número de licencia de E-Gaming 8048 / JAZ. <br><br>Actualmente contamos con oficinas centrales en Europa y en América , localizadas en Lima, Ciudad de México, Maracay y Almería.",
          },
          {
            "title":"Servicio",
            "icon":"fas fa-headset",
            "text":"Gangabet se esfuerza en ofrecer un servicio justo, personal transparente en el cual tratamos de mejorar el conocimiento que nuestros clientes tienen acerca del juego online.",
          },
          {
            "title":"Juego responsable",
            "icon":"fa fa-star",
            "text":"En Gangabet, continuaremos esforzándonos, trabajando duro y enfocándonos en la innovación y desarrollo de nuevos productos, así como en continuar asentando los estándares para un uso responsable del juego.",
          },
          {
            "title":"Nuestro nombre",
            "icon":"fa fa-pen-nib",
            "text":"Quizás te preguntaste de dónde proviene nuestro nombre Gangabet, este nombre se ha escogido por diversos motivos, el primero es que es corto, intuitivo y casi imposible de olvidar, el segundo es porque queremos que nuestros clientes sigan nuestro lema: <br>“No es una oferta, ni es un regalo, ¡Es Gangabet!”",
          }
        ],
        "ve": [
          {
            "title":"Gangabet",
            "icon":"fa fa-globe-americas",
            "text":"Gangabet es una marca de Wymsistem Bv, compañía registrada en el gobierno de Curazao, con domicilio en Fransche Bloemweg 4 bajo el número de licencia de E-Gaming 8048 / JAZ. <br><br>Actualmente contamos con oficinas centrales en Europa y en América , localizadas en Lima, Ciudad de México, Maracay y Almería.",
          },
          {
            "title":"Servicio",
            "icon":"fas fa-headset",
            "text":"Gangabet se esfuerza en ofrecer un servicio justo, personal transparente en el cual tratamos de mejorar el conocimiento que nuestros clientes tienen acerca del juego online.",
          },
          {
            "title":"Juego responsable",
            "icon":"fa fa-star",
            "text":"En Gangabet, continuaremos esforzándonos, trabajando duro y enfocándonos en la innovación y desarrollo de nuevos productos, así como en continuar asentando los estándares para un uso responsable del juego.",
          },
          {
            "title":"Nuestro nombre",
            "icon":"fa fa-pen-nib",
            "text":"Quizás te preguntaste de dónde proviene nuestro nombre Gangabet, este nombre se ha escogido por diversos motivos, el primero es que es corto, intuitivo y casi imposible de olvidar, el segundo es porque queremos que nuestros clientes sigan nuestro lema: <br>“No es una oferta, ni es un regalo, ¡Es Gangabet!”",
          }
        ],
        "br": [
          {
            "title":"Gangabet",
            "icon":"fa fa-globe-americas",
            "text":"Gangabet é uma marca comercial da Wymsistem Bv, uma empresa registrada no governo de Curaçao, domiciliada em Fransche Bloemweg 4 sob a licença E-Gaming número 8048 / JAZ. <br><br>Atualmente temos escritórios centrais na Europa e América, localizados em Lima, Cidade do México, Maracay e Almería.",
          },
          {
            "title":"Servicio",
            "icon":"fas fa-headset",
            "text":"A Gangabet se esforça para oferecer um serviço pessoal justo e transparente, no qual tentamos melhorar o conhecimento que nossos clientes têm sobre jogos de azar online.",
          },
          {
            "title":"Juego responsable",
            "icon":"fa fa-star",
            "text":"Na Gangabet, continuaremos a nos esforçar, trabalhar duro e focar na inovação e no desenvolvimento de novos produtos, bem como continuar a definir o padrão de jogo responsável.",
          },
          {
            "title":"Nuestro nombre",
            "icon":"fa fa-pen-nib",
            "text":"Talvez você se pergunte de onde vem nosso nome Gangabet, este nome foi escolhido por vários motivos, o primeiro é que é curto, intuitivo e quase impossível de esquecer, o segundo é porque queremos que nossos clientes sigam nosso lema: <br> “Não, não é uma oferta, nem é um presente, é Gangabet!”",
          }
        ]
      },

      "homeAboutUsExtras":{
        "br":[
          {
            "title":"",
            "icon":"fa fa-globe-americas",
            "text":"PROBABILIDADES ALTAS",
          },
          {
            "title":"",
            "icon":"fas fa-futbol",
            "text":"SOPORTE TECNICO 24/7",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"PROMOCIONES Y BONOS",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"GIROS DE CASINO Y BONOS CRÉDITO",
          }
        ],
        "cl":[
          {
            "title":"",
            "icon":"fa fa-globe-americas",
            "text":"PROBABILIDADES ALTAS",
          },
          {
            "title":"",
            "icon":"fas fa-futbol",
            "text":"SOPORTE TECNICO 24/7",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"PROMOCIONES Y BONOS",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"GIROS DE CASINO Y BONOS CRÉDITO",
          }
        ],
        "pe":[
          {
            "title":"",
            "icon":"fa fa-globe-americas",
            "text":"PROBABILIDADES ALTAS",
          },
          {
            "title":"",
            "icon":"fas fa-futbol",
            "text":"SOPORTE TECNICO 24/7",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"PROMOCIONES Y BONOS",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"GIROS DE CASINO Y BONOS CRÉDITO",
          }
        ],
        "pa":[
          {
            "title":"",
            "icon":"fa fa-globe-americas",
            "text":"PROBABILIDADES ALTAS",
          },
          {
            "title":"",
            "icon":"fas fa-futbol",
            "text":"SOPORTE TECNICO 24/7",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"PROMOCIONES Y BONOS",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"GIROS DE CASINO Y BONOS CRÉDITO",
          }
        ],
        "mx":[
          {
            "title":"",
            "icon":"fa fa-globe-americas",
            "text":"PROBABILIDADES ALTAS",
          },
          {
            "title":"",
            "icon":"fas fa-futbol",
            "text":"SOPORTE TECNICO 24/7",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"PROMOCIONES Y BONOS",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"GIROS DE CASINO Y BONOS CRÉDITO",
          }
        ],
        "ve":[
          {
            "title":"",
            "icon":"fa fa-globe-americas",
            "text":"PROBABILIDADES ALTAS",
          },
          {
            "title":"",
            "icon":"fas fa-futbol",
            "text":"SOPORTE TECNICO 24/7",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"PROMOCIONES Y BONOS",
          },
          {
            "title":"",
            "icon":"far fa-credit-card",
            "text":"GIROS DE CASINO Y BONOS CRÉDITO",
          }
        ]
      },



  "homeWork":{
    "cl":[
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Se beneficiará de una comisión generosa del neto de cada cliente que refiera durante su unión comercial junto a nosotros.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" A efectos de comisión contarán tanto las actividades de apuestas deportivas como de juegos de casino, casino en vivo, deportes virtuales o e-sports de los clientes referidos.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Ponemos a su disposición más datos, análisis y estadísticas sobre su cuenta de afiliado que en cualquier otro sitio web.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" El programa de afiliados de Gangabet es totalmente gratis y no cuesta ningún dinero registrarse.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Al relacionar su página web con los productos de Gangabet, se asocia con un proveedor global de juego de alta reputación y bien establecido en el sector del juego.",
      }
    ],
    "mx":[
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Se beneficiará de una comisión generosa del neto de cada cliente que refiera durante su unión comercial junto a nosotros.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" A efectos de comisión contarán tanto las actividades de apuestas deportivas como de juegos de casino, casino en vivo, deportes virtuales o e-sports de los clientes referidos.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Ponemos a su disposición más datos, análisis y estadísticas sobre su cuenta de afiliado que en cualquier otro sitio web.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" El programa de afiliados de Gangabet es totalmente gratis y no cuesta ningún dinero registrarse.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Al relacionar su página web con los productos de Gangabet, se asocia con un proveedor global de juego de alta reputación y bien establecido en el sector del juego.",
      }
    ],
    "pa":[
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Se beneficiará de una comisión generosa del neto de cada cliente que refiera durante su unión comercial junto a nosotros.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" A efectos de comisión contarán tanto las actividades de apuestas deportivas como de juegos de casino, casino en vivo, deportes virtuales o e-sports de los clientes referidos.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Ponemos a su disposición más datos, análisis y estadísticas sobre su cuenta de afiliado que en cualquier otro sitio web.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" El programa de afiliados de Gangabet es totalmente gratis y no cuesta ningún dinero registrarse.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Al relacionar su página web con los productos de Gangabet, se asocia con un proveedor global de juego de alta reputación y bien establecido en el sector del juego.",
      }
    ],
    "pe":[
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Se beneficiará de una comisión generosa del neto de cada cliente que refiera durante su unión comercial junto a nosotros.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" A efectos de comisión contarán tanto las actividades de apuestas deportivas como de juegos de casino, casino en vivo, deportes virtuales o e-sports de los clientes referidos.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Ponemos a su disposición más datos, análisis y estadísticas sobre su cuenta de afiliado que en cualquier otro sitio web.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" El programa de afiliados de Gangabet es totalmente gratis y no cuesta ningún dinero registrarse.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Al relacionar su página web con los productos de Gangabet, se asocia con un proveedor global de juego de alta reputación y bien establecido en el sector del juego.",
      }
    ],
    "ve":[
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Se beneficiará de una comisión generosa del neto de cada cliente que refiera durante su unión comercial junto a nosotros.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" A efectos de comisión contarán tanto las actividades de apuestas deportivas como de juegos de casino, casino en vivo, deportes virtuales o e-sports de los clientes referidos.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Ponemos a su disposición más datos, análisis y estadísticas sobre su cuenta de afiliado que en cualquier otro sitio web.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" El programa de afiliados de Gangabet es totalmente gratis y no cuesta ningún dinero registrarse.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Al relacionar su página web con los productos de Gangabet, se asocia con un proveedor global de juego de alta reputación y bien establecido en el sector del juego.",
      }
    ],
    "br":[
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Você ganhará uma generosa comissão da rede de cada cliente que indicar durante sua parceria comercial conosco.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Para efeitos de comissão, contarão tanto as atividades de apostas desportivas como os jogos de casino, casino ao vivo, desportos virtuais ou e-sports dos referidos clientes.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Disponibilizamos mais dados, análises e estatísticas sobre sua conta de afiliado do que em qualquer outro site.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" O programa de afiliados Gangabet é totalmente gratuito e não custa dinheiro para se inscrever.",
      },
      {
        "title":"",
        "subtitle":"",
        "image":"/assets/images/home/metricas.png",
        "text":" Ao vincular seu site aos produtos Gangabet, você está fazendo parceria com um provedor de jogos global altamente respeitável e bem estabelecido na indústria de jogos.",
      }
    ]
  },

  "homeCommissions":{
    "br":[
        {
          "step1":"( APOSTAS - PRÊMIOS - BÔNUS - IMPOSTOS )",
          "step2":"VALOR LÍQUIDO",
          "step3":"(%) PORCENTAGEM ACORDADA",
          "text":"Você receberá ganhos com base nos usuários que, por meio de publicidade em sua plataforma, <br>registre-se e aposte no Gangabet até 25%!<br><br>O cálculo das comissões dependerá do lucro líquido ou Receita Líquida do Jogo:",
          "background": "/assets/images/shapes/testi-shape-1-1.png"
        }
    ],
    "cl":[
        {
          "step1":"( APUESTAS - PREMIOS - BONOS - IMPUESTOS )",
          "step2":"MONTO NETO",
          "step3":"(%) PORCENTAJE ACORDADO",
          "text":"Recibirás ganancias basadas en los usuarios que, a través de la publicidad en tu plataforma, <br>se registren y apuesten en Gangabet ¡hasta un 25%! <br><br>El cálculo de las comisiones dependerá de la ganancia neta o Net Gaming Revenue:",
          "background": "/assets/images/shapes/testi-shape-1-1.png"
        }
    ],
    "mx":[
        {
          "step1":"( APUESTAS - PREMIOS - BONOS - IMPUESTOS )",
          "step2":"MONTO NETO",
          "step3":"(%) PORCENTAJE ACORDADO",
          "text":"Recibirás ganancias basadas en los usuarios que, a través de la publicidad en tu plataforma, <br>se registren y apuesten en Gangabet ¡hasta un 25%! <br><br>El cálculo de las comisiones dependerá de la ganancia neta o Net Gaming Revenue:",
          "background": "/assets/images/shapes/testi-shape-1-1.png"
        }
    ],
    "pa":[
        {
          "step1":"( APUESTAS - PREMIOS - BONOS - IMPUESTOS )",
          "step2":"MONTO NETO",
          "step3":"(%) PORCENTAJE ACORDADO",
          "text":"Recibirás ganancias basadas en los usuarios que, a través de la publicidad en tu plataforma, <br>se registren y apuesten en Gangabet ¡hasta un 25%! <br><br>El cálculo de las comisiones dependerá de la ganancia neta o Net Gaming Revenue:",
          "background": "/assets/images/shapes/testi-shape-1-1.png"
        }
    ],
    "pe":[
        {
          "step1":"( APUESTAS - PREMIOS - BONOS - IMPUESTOS )",
          "step2":"MONTO NETO",
          "step3":"(%) PORCENTAJE ACORDADO",
          "text":"Recibirás ganancias basadas en los usuarios que, a través de la publicidad en tu plataforma, <br>se registren y apuesten en Gangabet ¡hasta un 25%! <br><br>El cálculo de las comisiones dependerá de la ganancia neta o Net Gaming Revenue:",
          "background": "/assets/images/shapes/testi-shape-1-1.png"
        }
    ],
    "ve":[
        {
          "step1":"( APUESTAS - PREMIOS - BONOS - IMPUESTOS )",
          "step2":"MONTO NETO",
          "step3":"(%) PORCENTAJE ACORDADO",
          "text":"Recibirás ganancias basadas en los usuarios que, a través de la publicidad en tu plataforma, <br>se registren y apuesten en Gangabet ¡hasta un 25%! <br><br>El cálculo de las comisiones dependerá de la ganancia neta o Net Gaming Revenue:",
          "background": "/assets/images/shapes/testi-shape-1-1.png"
        }
    ]
  },

  "homeRequirements":{
        "pe":[
            {
              "title":"Contenido",
              "icon":"fas fa-football-ball",
              "text":"El sitio web debe tener contenido relacionado con la marca: marcadores, deportes, resultados, pronósticos, etc.",
            },
            {
              "title":"Tráfico",
              "icon":"fas fa-users",
              "text":"Tu sitio debe contar con un buen tráfico:<br><br><i class='fa fa-check'></i> Sitio web: Más de 2.000 sesiones en los últimos dos meses <br><i class='fa fa-check'></i> Redes sociales:  Más de 10.000 seguidores <br><i class='fa fa-check'></i> Canales de difusión directos:  Más de 1.000 suscriptores",
            },
            {
              "title":"Documentación",
              "icon":"fas fa-balance-scale-right",
              "text":"Si estás en Perú, la documentación requerida es RUC y documento de identidad; sí estás fuera del país, la documentación requerida es una copia de tu pasaporte.",
            }
          ],
        "cr":[
            {
              "title":"Contenido",
              "icon":"fas fa-football-ball",
              "text":"El sitio web debe tener contenido relacionado con la marca: marcadores, deportes, resultados, pronósticos, etc.",
            },
            {
              "title":"Tráfico",
              "icon":"fas fa-users",
              "text":"Tu sitio debe contar con un buen tráfico:<br><br><i class='fa fa-check'></i> Sitio web: Más de 2.000 sesiones en los últimos dos meses <br><i class='fa fa-check'></i> Redes sociales:  Más de 10.000 seguidores <br><i class='fa fa-check'></i> Canales de difusión directos:  Más de 1.000 suscriptores",
            },
            {
              "title":"Documentación",
              "icon":"fas fa-balance-scale-right",
              "text":"Si estás en Perú, la documentación requerida es RUC y documento de identidad; sí estás fuera del país, la documentación requerida es una copia de tu pasaporte.",
            }
          ]
  },

  "footerMenu":[
    {
      "title":"Acerca de Gangabet",
      "href":"#about-us",
      "icon":""
    },
    {
      "title":"¿Por qué trabajar con nosotros?",
      "href":"#work",
      "icon":""
    },
    {
      "title":"Comisiones",
      "href":"#commissions",
      "icon":""
    },
    {
      "title":"Crear una cuenta",
      "href":"/register",
      "icon":""
    },
    {
      "title":"Iniciar Sesión",
      "href":"/login",
      "icon":""
    }
  ],

  "headerMenu":[
    {
      "title":"Acerca de Gangabet",
      "href":"#about-us",
      "icon":""
    },
    {
      "title":"¿Por qué trabajar con nosotros?",
      "href":"#work",
      "icon":""
    },
    {
      "title":"Comisiones",
      "href":"#commissions",
      "icon":""
    },
  ],

   "socialMenu":[
    {
      "title":"facebook",
      "href":"https://www.facebook.com/gangabetoficial/",
      "icon":"fab fa-facebook-square"
    },
    {
      "title":"twitter",
      "href":"https://twitter.com/gangabetoficial",
      "icon":"fab fa-twitter"
    },{
      "title":"instagram",
      "href":"https://www.instagram.com/gangabetperu/",
      "icon":"fab fa-instagram"
    }
  ],

  "footer":{
    "br":[
        {
          "aboutUs":"Monetize o tráfego do seu site através do nosso programa de afiliados e comece a multiplicar seu entusiasmo com esta grande oportunidade.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ],
    "pe":[
        {
          "aboutUs":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ],
    "cl":[
        {
          "aboutUs":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ],
    "mx":[
        {
          "aboutUs":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ],
    "pa":[
        {
          "aboutUs":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ],
    "pe":[
        {
          "aboutUs":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ],
    "ve":[
        {
          "aboutUs":"Monetiza el tráfico de tu sitio web a través de nuestro programa de Afiliados y empieza a multiplicar tu emoción con esta gran oportunidad.",
          "copyright":"<i class='fa fa-copyright'></i> Esta página web es operada por iTains N.V., una compañía registrada el 18 de Marzo del 2011 bajo las leyes de Curazao, con el registro No122623 y bajo la licencia No 1668/JAZ otorgada por el Gobierno de Curazao el 1ro de Julio del 2011",
        }
    ]
  },


  "languagesData":[
    {
      "language":"en",
      "data":{
        "Acceder":"Access",
        "Registrarse":"Register",
      }
    },
    {
      "language":"es",
      "data":{
        "Acceder":"Acceder",
        "Registrarse":"Registrarse"
      }
    }
  ]
}
